export enum HotelWebParams {
    ResNoZorunlu,
    MailDili,
    KonfirmReplyTo,
    NotKonfirmReplyTo,
    StopSaleReplyTo,
    FreeSaleReplyTo,
    OtelBilgiFormuReplyTo,
    OfferMail,
    SpoNotificationReplyTo,
    HotelMailLanguage,
    ListResAutomatically,
    RemindersReservationInterval,
    RemindersReservationMail
}